import { db } from "./index.js";
import { DebugLogger } from "./debugLogger.js";

export async function addFileToQueue({
  sanitationRouteId,
  routeDatapointId = null,
  customFieldId,
  treeNumber,
  questionType,
  datapointCreatedAt = null,
  fileLocalId,
  fileName,
  fileSize,
  fileType,
  localPath,
}) {
  const currentTimestamp = new Date().toISOString();

  const fileQueueId = await db.fileQueue.add({
    sanitation_route_id: sanitationRouteId,
    route_datapoint_id: routeDatapointId,
    custom_field_id: customFieldId,
    tree_number: treeNumber,
    question_type: questionType,
    datapoint_created_at: datapointCreatedAt,
    file_local_id: fileLocalId,
    file_name: fileName,
    file_size: fileSize,
    file_type: fileType,
    local_path: localPath,
    upload_status: "pending",
    upload_progress: 0,
    error_message: null,
    created_at: currentTimestamp,
    uploaded_at: null,
  });

  DebugLogger.info("Local file queued for route upload", {
    fileQueueId,
    sanitationRouteId,
    routeDatapointId,
    customFieldId,
    fileLocalId,
    fileName,
    fileSize,
  });

  return fileQueueId;
}

export async function getFileQueueByRoute(sanitationRouteId) {
  return await db.fileQueue
    .where("sanitation_route_id")
    .equals(sanitationRouteId)
    .toArray();
}

export async function getPendingFilesByRoute(sanitationRouteId) {
  return await db.fileQueue
    .where("sanitation_route_id")
    .equals(sanitationRouteId)
    .and((file) => file.upload_status === "pending")
    .toArray();
}

export async function updateFileQueueStatus(
  fileQueueId,
  status,
  progress = null,
  errorMessage = null
) {
  // Add defensive check for fileQueueId
  if (fileQueueId == null) {
    console.error(
      "updateFileQueueStatus called with null/undefined fileQueueId"
    );
    return;
  }

  const updateData = {
    upload_status: status,
    upload_progress: progress || 0,
    error_message: errorMessage,
  };

  if (status === "completed") {
    updateData.uploaded_at = new Date().toISOString();
  }

  return await db.fileQueue.update(fileQueueId, updateData);
}

export async function deleteFileFromQueue(fileQueueId) {
  return await db.fileQueue.delete(fileQueueId);
}

export async function deleteFileQueueByRoute(sanitationRouteId) {
  const files = await getFileQueueByRoute(sanitationRouteId);

  for (const file of files) {
    await deleteFileFromQueue(file.id);
  }
}

export async function getFailedFilesByRoute(sanitationRouteId) {
  return await db.fileQueue
    .where("sanitation_route_id")
    .equals(sanitationRouteId)
    .and((file) => file.upload_status === "failed")
    .toArray();
}
